import { render, staticRenderFns } from "./Reservaciones.vue?vue&type=template&id=1c1bc75e&scoped=true"
import script from "./Reservaciones.vue?vue&type=script&lang=js"
export * from "./Reservaciones.vue?vue&type=script&lang=js"
import style0 from "./Reservaciones.vue?vue&type=style&index=0&id=1c1bc75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bc75e",
  null
  
)

export default component.exports